import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../../hrm/hrmTour.css";

export function startSalaryListTour() {
  const steps = [
    {
      popover: {
        title: "Quản lý lương nhân sự — Production tour",
        description:
          "Tour này đi qua luồng: tạo kỳ lương → tính lương → gửi duyệt COO → CEO duyệt → công bố phiếu lương cho nhân viên.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    [
      '[data-tour="finance-salary-header"]',
      "Tiêu đề trang",
      "Bên phải có Production tour (hướng dẫn nhanh trên màn hình) và Documentation (tài liệu quy trình đầy đủ).",
      "bottom",
    ],
    [
      '[data-tour="finance-salary-filter"]',
      "Bộ lọc & tạo kỳ",
      "Tìm theo tháng/mã kỳ, lọc nâng cao theo tháng–chi nhánh–trạng thái. Nút «Tạo kỳ lương» chỉ dùng sau khi Nhân sự đã chốt công tháng đó.",
      "bottom",
    ],
    [
      '[data-tour="finance-salary-pending"]',
      "Kỳ lương chờ duyệt",
      "Các kỳ đang ở trạng thái Chờ COO hoặc Chờ CEO. Bấm để mở chi tiết và duyệt/từ chối.",
      "right",
    ],
    [
      '[data-tour="finance-salary-runs"]',
      "Danh sách kỳ lương",
      "Toàn bộ kỳ lương theo bộ lọc. Chọn một kỳ để xem chi tiết, bảng lương và thao tác bên phải.",
      "right",
    ],
    [
      '[data-tour="finance-salary-detail"]',
      "Chi tiết kỳ lương",
      "Xem trạng thái, tổng gross/net, tiến trình duyệt. Kế toán: Tính lương → chỉnh điều chỉnh → Gửi duyệt. COO/CEO: Duyệt hoặc Từ chối (trả về Kế toán). Sau khi CEO duyệt: Công bố để nhân viên xem phiếu lương.",
      "left",
    ],
  ];

  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang rồi thử lại.");
    return;
  }

  driver({
    showProgress: true,
    smoothScroll: true,
    popoverClass: "hrm-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    steps,
  }).drive();
}
